var UtilSkipProcess = /** @class */ (function () {
    function UtilSkipProcess() {
        this.calculateCostToSkipProcess = function (remainingTime, factor) {
            return Math.ceil(Math.ceil(remainingTime / 60.0) * factor);
        };
        this.calculateQuestTaskSkipCost = function (currentAmount, requiredAmount, skipCost) {
            var factor = Math.max(0, 1 - currentAmount / requiredAmount);
            return Math.ceil(factor * skipCost);
        };
    }
    return UtilSkipProcess;
}());
export var utilSkipProcess = new UtilSkipProcess();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilSkipProcess.ts
// module id = 196
// module chunks = 3